export default __webpack_public_path__ + "static/media/account-img.c4e76b4f.svg";